var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgServerErrorDocument = function SvgServerErrorDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 134,
    viewBox: "0 0 112 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.174 131C106.513 131 108.739 128.774 108.739 125.435V36.3913C108.739 18.0261 93.7129 3 75.3476 3H8.56521C5.22611 3 3 5.22611 3 8.56521V125.435C3 128.774 5.22611 131 8.56521 131H103.174Z",
    stroke: "#FF711F",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6484 3.24023V31.8575C72.6484 36.2602 75.5835 39.1953 79.9861 39.1953H108.604",
    stroke: "#FF711F",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5007 57.5062C37.7064 57.5062 37.0625 56.8625 37.0625 56.068C37.0625 55.2737 37.7064 54.6299 38.5007 54.6299",
    stroke: "#FF711F",
    strokeWidth: 6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 57.5062C39.2943 57.5062 39.9382 56.8625 39.9382 56.068C39.9382 55.2737 39.2943 54.6299 38.5 54.6299",
    stroke: "#FF711F",
    strokeWidth: 6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9675 57.5062C72.1736 57.5062 71.5293 56.8625 71.5293 56.068C71.5293 55.2737 72.1736 54.6299 72.9675 54.6299",
    stroke: "#FF711F",
    strokeWidth: 6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9688 57.5062C73.7632 57.5062 74.407 56.8625 74.407 56.068C74.407 55.2737 73.7632 54.6299 72.9688 54.6299",
    stroke: "#FF711F",
    strokeWidth: 6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5938 95.0971C33.2122 84.1236 43.5479 76.2031 55.7335 76.2031C67.9191 76.2031 78.2546 84.1236 81.8731 95.0971",
    stroke: "#FF711F",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
};
export default SvgServerErrorDocument;